import React from 'react'
import { array, bool, oneOfType, string, node, oneOf } from 'prop-types'
import styled from 'styled-components'

const StoryContainer = styled.div`
  .story-wrapper {
    //padding: 0 0 10px 10px;
    //background-color: #f5f5f5;
    //box-shadow: 0 10px 10px -15px #111;
    line-height: 18px;

    .story-wrapper-title {
      color: #303030;
      margin-bottom: 10px;
    }

    .story-wrapper-desc-list {
      padding-bottom: 10px;
      color: #303030;
      margin-bottom: 5px;
      > li {
        margin-top: 5px;
      }
    }

    .prototyp-link-list {
      list-style-type: none;
      padding: 0;
      li {
        margin-top: 5px;
        a {
          font-size: smaller;
          text-decoration: none;
          color: #008a34;
        }
      }
    }
  }
`

const StoryWrapper = ({
  title,
  list,
  children,
  headlineElement = 'h1',
  protoTypLink,
}) => {
  const Headline = headlineElement

  return (
    <StoryContainer>
      <div className='story-wrapper'>
        <Headline className='story-wrapper-title'>{title}</Headline>
        {list && (
          <ul className='story-wrapper-desc-list'>
            {list.map((text, index) => (
              <li key={ index }>{text}</li>
            ))}
          </ul>
        )}
        {protoTypLink && (
          <ul className='prototyp-link-list'>
            {protoTypLink.map((protoLink, key) => (
              <li key={ key }>
                <a href={ protoLink } target='_blank'>
                  >> Link ({key + 1}) im Prototypen
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
      {children && children}
    </StoryContainer>
  )
}

StoryWrapper.defaultProps = {
  list: false,
  children: false,
  protoTypLink: false,
}

StoryWrapper.propTypes = {
  title: string,
  list: oneOfType([array, bool]),
  children: oneOfType([node, bool]),
  headlineElement: oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  protoTypLink: oneOfType([array, bool]),
}

export default StoryWrapper
